import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";

/* The suggestion to stop renewing by hand: a card that renews by itself */
export const SwitchToCard = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 1rem 1.125rem;
  background: rgba(87, 242, 139, 0.08);
  border: 1px dashed rgba(87, 242, 139, 0.45);
  border-radius: 1rem;

  .text {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.1875rem;
    min-width: 0;

    b {
      font-size: 0.875rem;
      font-weight: 700;
      color: var(--color-neutral-white);
    }

    span {
      font-size: 0.75rem;
      line-height: 1.125rem;
      color: var(--color-neutral-150);
    }
  }

  button {
    flex-shrink: 0;
    padding: 0.5rem 0.875rem;
    font-size: 0.8125rem;
    font-weight: 800;
    color: var(--color-neutral-darkness);
    background: var(--color-brand-plus);
    border-radius: 100px;
  }

  @media not all and (min-width: ${DESKTOP_BREAKPOINT}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
